import React from 'react';
import {
  List,
  Datagrid,
  Create,
  SimpleForm,
  EditButton,
  DeleteButton,
  TextInput,
  TextField,
  translate as t,
} from 'admin-on-rest';

import Edit from '../components/Edit';

export const SupplierList = (props) => (
  <List {...props}>
    <Datagrid>
      <TextField source="name" />
      <EditButton {...props} basePath="/suppliers" />
      <DeleteButton {...props} basePath="/suppliers" />
    </Datagrid>
  </List>
);

const SupplierTitle = t(({ record, translate }) => (
  <span>{record ? translate('edit.title', { title: record.name }) : ''}</span>
));

export const SupplierEdit = (props) => (
  <Edit title={<SupplierTitle />} {...props}>
    <SimpleForm>
      <TextInput source="name" />
    </SimpleForm>
  </Edit>
);

export const SupplierCreate = (props) => (
  <Create {...props}>
    <SimpleForm redirect="list">
      <TextInput source="name" />
    </SimpleForm>
  </Create>
);
